import { Autocomplete, TextField, createFilterOptions } from "@mui/material";
import { useNavigate } from "react-router";
import { PATH_DASHBOARD } from "routes/paths";

type Props = {
  setSelectedImage: (ImageId: string) => void;
  imageOptions: Array<Record<string, string>>;
  defaultValue?: Record<string, string>;
};

export default function ImageAutoComplete({
  setSelectedImage,
  imageOptions,
  defaultValue,
}: Props) {
  const navigate = useNavigate();

  const filter = createFilterOptions<Record<string, string>>();

  return (
    <Autocomplete
      id="contentUnitAutoComplete"
      options={Object.values(imageOptions)}
      defaultValue={defaultValue}
      getOptionLabel={(option) => option?.id}
      renderOption={(props, option) => (
        <li {...props}>
          {option?.title} {option?.id}
        </li>
      )}
      onChange={(_, value) => {
        if (!value) {
          return;
        }

        setSelectedImage(value?.id);

        navigate(`${PATH_DASHBOARD.contentImages.root}/${value?.id}`);
      }}
      sx={{ width: 300 }}
      renderInput={(params) => (
        <TextField {...params} label="Search for images by ID" />
      )}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);

        if (params?.inputValue !== "") {
          filtered.push({
            id: params?.inputValue,
            title: `Add "${params?.inputValue}"`,
          });
        }

        return filtered;
      }}
    />
  );
}
